import React from "react";

/**
 * Videra mark — two angular strokes that read as a V and as a tick, the shorter one kicking up
 * and out like a delivery line. Single-colour by default so it inherits text colour; pass `accent`
 * to give the ascending stroke its own colour.
 */
export const VideraMark = ({
  size = 22,
  className = "",
  color = "currentColor",
  accent,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    className={className}
    aria-hidden="true"
    {...rest}
  >
    <path d="M6 10h13l14 34-6.5 10z" fill={color} />
    <path
      d="M58 10H45L33.5 38l6.5 10z"
      fill={accent || color}
      opacity={accent ? 1 : 0.55}
    />
  </svg>
);

export default VideraMark;
